export default "__VITE_ASSET__40a02642__"